import { render, staticRenderFns } from "./BarcodeScannerButton.vue?vue&type=template&id=456e28ee&scoped=true"
import script from "./BarcodeScannerButton.vue?vue&type=script&lang=js"
export * from "./BarcodeScannerButton.vue?vue&type=script&lang=js"
import style0 from "./BarcodeScannerButton.vue?vue&type=style&index=0&id=456e28ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e28ee",
  null
  
)

export default component.exports